import React from 'react'
import Typography from "@mui/material/Typography";
import UsersLayout from '../../layout/Users';

const Users = () => {
  return (
    <div className="mainDiv">
         <Typography className="heading">Users</Typography>
        <UsersLayout /> 
    </div>
  )
}

export default Users

